import {DEFAULT_LOCALE} from '../../constants';
import {Locale} from '../../RootProvider/LocaleContext';
import {ObjectOfAny} from '../../types';
import {mergeDeep} from '../objects';
import en from './en-routes.json';
import nl from './nl-routes.json';

export const DEFAULT_ROUTES_CONFIG_KEY = 'en';
export const routeData = {
  [DEFAULT_ROUTES_CONFIG_KEY]: en,
  // create a clone of En, with Nl routes where possible
  // had to use JSON to clone En so it doesn't get overwritten elsewhere
  // @todo clean this up
  nl: mergeDeep(JSON.parse(JSON.stringify(en)), nl),
} as ObjectOfAny;

export const rawRouteData = {
  [DEFAULT_ROUTES_CONFIG_KEY]: en,
  nl,
} as ObjectOfAny;

const getMessages = (locale: string = DEFAULT_LOCALE): ObjectOfAny => {
  // test hatch - use blank translations so key is displayed
  if (locale === Locale.test) {
    return {};
  }

  let lang;

  // nl overloads
  switch (locale) {
    case Locale.nl:
    // fallthrough
    case 'nl-NL':
      lang = 'nl';
      break;
    default:
      lang = DEFAULT_ROUTES_CONFIG_KEY;
  }

  // language and missing translations from selected locale fallback to english
  return routeData[lang];
};

export const getRoutesData = (locale: Locale): ObjectOfAny => getMessages(locale);
